<template>
  <div
    class="user-profile-sidebar"
    :class="{'show': shallShowActiveChatContactSidebar}"
  >
    <!-- Header -->
    <header
      class="user-profile-header"
    >
      <span class="close-icon">
        <feather-icon
          icon="XIcon"
          @click="$emit('update:shall-show-active-chat-contact-sidebar', false)"
        />
      </span>

      <div class="header-profile-sidebar">
        <div class="avatar box-shadow-1 avatar-xl avatar-border mt-3">
          <b-avatar
            size="130"
            v-if="member.member_id > 0"
            :src="'//www.cloudfit.pro/memberPhoto/'+member.token+'.jpg'"
          />
          <b-avatar
            v-else
            size="130"
            :src="contact.avatar"
          />
          <!-- <span
            class="avatar-status-xl"
            :class="`avatar-status-${contact.status}`"
          /> -->
        </div>
                <b-badge v-if="member.member_code === ''" variant="light-danger">Non-member</b-badge>
        <h4 class="chat-user-name">
          {{ member.zh_name }} {{ member.en_name }}
        </h4>
        <span class="user-post text-capitalize">{{ member.member_code }}</span>
      </div>
    </header>

    <!-- User Details -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="user-profile-sidebar-area scroll-area"
    >

      <!-- About -->
  
     

      <!-- Personal Info -->
      <div class="personal-info" v-if="member.member_id > 0">
        <h6 class="section-label mb-1 mt-3">
          Personal Information
        </h6>
        <ul class="list-unstyled">
          <li class="mb-1">
            <feather-icon
              icon="MailIcon"
              size="16"
              class="mr-75"
            />
            <span class="align-middle">  {{ member.email ? member.email : null }}</span>
          </li>
          <li class="mb-1">
            <feather-icon
              icon="PhoneCallIcon"
              size="16"
              class="mr-75"
            />
            <span class="align-middle">{{ member.mobile ? member.mobile : null }}</span>
          </li>
          
        </ul>
      </div>

      <!-- More Options -->
       <!--
      <div class="more-options">
        <h6 class="section-label mb-1 mt-3">
          Options
        </h6>
        <ul class="list-unstyled">
          <li class="cursor-pointer mb-1">
            <feather-icon
              icon="TagIcon"
              size="16"
              class="mr-75"
            />
            <span class="align-middle">Add Tag</span>
          </li>
          <li class="cursor-pointer mb-1">
            <feather-icon
              icon="StarIcon"
              size="16"
              class="mr-75"
            />
            <span class="align-middle">Important Contact</span>
          </li>
          <li class="cursor-pointer mb-1">
            <feather-icon
              icon="ImageIcon"
              size="16"
              class="mr-75"
            />
            <span class="align-middle">Shared Media</span>
          </li>
          <li class="cursor-pointer mb-1">
            <feather-icon
              icon="TrashIcon"
              size="16"
              class="mr-75"
            />
            <span class="align-middle">Delete Contact</span>
          </li>
          <li class="cursor-pointer">
            <feather-icon
              icon="SlashIcon"
              size="16"
              class="mr-75"
            />
            <span class="align-middle">Block Contact</span>
          </li>
        </ul>
      </div>
      -->
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { BAvatar,BBadge } from 'bootstrap-vue'

export default {
  components: {
    // BSV
    BAvatar,
    BBadge,
    VuePerfectScrollbar,
  },
  props: {
    shallShowActiveChatContactSidebar: {
      type: Boolean,
      required: true,
    },
    customer: {
      type: String,
      required: true,
    },
    contact: {
      type: Object,
      required: true,
    },
  },
  watch: {
    customer(newVal) {
      this.member = {
                mobile: '',
                email: '',
                member_code: '',
                zh_name: '',
                en_name: '',
                member_id: '',
                token: ''
              }
        this.$http.get(process.env.VUE_APP_API_BASE+`/member/whatsapp_search_member/?mobile=`+newVal)
           .then(res => {
            if (res.data.exist === true) {
              this.member = res.data.member
            } 
        })
    },
  },
  setup() {
    const member = {
      mobile: '',
      email: '',
      member_code: '',
      zh_name: '',
      en_name: '',
      member_id: '',
      token: ''
    }
    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    }

    return {
      perfectScrollbarSettings,
      member
    }
  },
}
</script>

<style>

</style>
